import styled, { device } from '@styled'
import { space } from 'styled-system'

export const LanguageWrap = styled.div`
  ${space}
  img {
    margin-right: 5px;
  }
  a {
    width: 100%;
  }
`

export const FlagWrap = styled.div`
  width: 30px;
  display: none;
  ${device.small} {
    display: inline-block;
  }
  img {
    height: 20px;
  }
`
